import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';
import { postGenerateProjectListReport } from '../services/getProjectListReport.service';

export const generateProjectListReport = createAsyncThunk(
    'project/generateProjectListReport',
    async (dialogSettings, { getState }) => {
        const state = getState();

        const selectedProjectId = selectSelectedProjectId(state);

        const { language, filetype, selectedReportType } = dialogSettings;

        const generationParams = {
            language,
            filetype,
            selectedReportType,
        };

        const report = await postGenerateProjectListReport(
            selectedProjectId,
            generationParams
        );

        return report;
    }
);